import { confirm } from "components";
import { recursiveAPI } from "services";
import useOffcanvasStore from "store/offcanvasStore";
import { formatMoney } from "utils";

function EachRtxn(props) {
  const { txn, triggertxns } = props;
  const { openOffcanvas } = useOffcanvasStore((state) => state);

  const handleEdit = (e) => {
    openOffcanvas("editRecursiveTxn", { editRcTxn: txn });
  };

  const handleDelete = () => {
    confirm({
      message: "You want to delete this <b>Repeating Transaction</b>",
      onConfirm: () => {
        recursiveAPI.deleteRecursiveTxn(txn).then(() => {
          triggertxns();
        }).catch(console.log);
      }
    });

  };

  const handleEnable = () => {
    recursiveAPI.enableRecursiveTxn(txn.id).then(() => {
      triggertxns();
    }).catch(console.log);
  };

  const handleDisable = () => {
    recursiveAPI.disableRecursiveTxn(txn.id).then(() => {
      triggertxns();
    }).catch(console.log);
  };

  const formatInterval = (val) => {
    switch (val) {
      case 1: return "Daily";
      case 7: return "Once a Week";
      case 30: return "Once a Month";
      case 365: return "Once a Year";
      case 33: return "Last day of Month";
      default: return `${val} days`;
    }
  };

  const borderStyle = {
    borderLeft: `5px solid ${txn.get("enabled") ?
      (txn.get("amount") > 0 ? "#3b7d17ff" : "#e63946ff")
      : "#b9b7b7ff"}`
  };

  return (
    <div className="col-12 mb-3">
      <div className="card border" >
        <div className="card-body p-3 rounded" style={borderStyle}>
          <div className="d-flex align-items-center justify-content-between">
            <div>
                <span className={`h5 fw-bold ${txn.get("amount") < 0 ? "text-danger" : "text-success"}`}>
                  {formatMoney(Math.abs(txn.get("amount")))}
                </span>
                {txn.get("detail") && (
                  <span className="text-secondary small ms-3">
                    {txn.get("detail")}
                  </span>
                )}
              </div>
              <div class="d-flex w-25 justify-content-end align-items-center">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input custom-switch"
                    type="checkbox"
                    checked={txn.get("enabled")}
                    onChange={txn.get("enabled") ? handleDisable : handleEnable}
                  />
                </div>
                <button className="btn" onClick={handleDelete}>
                  <i className="bi bi-trash3-fill text-danger"></i>
                </button>
              </div>
          </div>

          <div class="d-flex justify-content-between">
            {/* show Interval */}
            <p className="badge rounded-pill bg-light text-muted border-0 fw-normal small px-2">
              {formatInterval(txn.get("interval"))}
            </p>
            {/* Show Status  */}
            <span class="">
              {txn.get("enabled") ?
                <span className="text-success small fw-medium d-flex align-items-center">
                  <span className="p-1 bg-success rounded-circle me-1 animate-pulse"></span> Active
                </span>
                :
                <span className="text-secondary small fw-medium d-flex align-items-center">
                  <span className="p-1 bg-secondary rounded-circle me-1 animate-pulse"></span> Paused
                </span>
              }
            </span>
          </div>

          <div className="bg-light rounded-4 p-2 d-flex justify-content-between align-items-center">
            <div className="ps-2">
              <div className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: '600'}}>Next Transaction</div>
              <span className="small fw-bold text-dark">{txn.get("nextTriggerDate")?.toLocaleDateString() || "Manual"}</span>
              {/* #Todo :  What is manual here ? */}
            </div>

            <div className="pe-1">
              <button className="btn btn-white btn-sm shadow-sm rounded-3 border" onClick={handleEdit}>
                <i className="bi bi-pencil-fill small text-primary"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default EachRtxn;